import { useQuery } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

const forceReloadMailingLists = () => queryClient.invalidateQueries({ queryKey: ['mailinglists'] });

const getMailingLists = () => {
    return Axios.get(`/MailingLists`);
};

const useMailingLists = () => {
    return useQuery({
        queryKey: ['mailinglists'],
        queryFn: getMailingLists,
        staleTime: 300000,
        cacheTime: Infinity,
        retry: false,
    });
};

export { useMailingLists, forceReloadMailingLists };
